﻿// Because we're using webpack and have configured it to understand `.scss`
// we're able to import this sass file and webpack will output it to a css file

import "./index.scss";
import { Modal, Tab } from "bootstrap";

import "./scripts/nav.js";
import "./scripts/carousel.js";
import "./scripts/dropdown.js";
import "./scripts/share.js";
import "./scripts/estimator.js";
import "./scripts/custom-select.js";
import "./scripts/lightbox.js";

const filtersModelElement = document.getElementById("filter-modal");

if (filtersModelElement) {
  const filtersModal = new Modal(filtersModelElement, {});
  document.addEventListener("open-filters", (e) => {
    filtersModal.show();
  });
}

window["Tab"] = Tab;

document
  .querySelector('.share-btn[href=""]')
  ?.addEventListener("click", (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(window.location.href);
  });

const ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent);
const android = /Android/i.test(window.navigator.userAgent);

if (ios || android) {
  document
    .querySelector('[data-bs-target="#share-modal"]')
    ?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigator.share({
        title: document.title,
        url: location.href,
      });
    });
  document
    .querySelector('[data-bs-target="#share-modal"]')
    ?.removeAttribute("data-bs-target");
}


document.
    querySelector('#enquiry-modal')?.addEventListener('show.bs.modal', (e) => {
        const eventTriggerElement = e.relatedTarget;
        if (eventTriggerElement == undefined) return;

        
        const enquiryMessageField = document.querySelector<HTMLTextAreaElement>('#EnquiryMessage');
        //on concierge, this field doesn't exist
        if (enquiryMessageField) {
            const enquiryMessage = eventTriggerElement.getAttribute('data-bs-enquirymessage');
            //enquiryMessage might be undefined, which is fine as it will clear the textarea
            enquiryMessageField.value = enquiryMessage;
        }

        const propertyVacancyField = document.querySelector<HTMLInputElement>('#PropertyVacancyId');

        if (propertyVacancyField) {
            const vacancyId = eventTriggerElement.getAttribute('data-bs-vacancyid');
            propertyVacancyField.value = vacancyId;
        }

    });


//when the page loads, check for the presence of a querysting parameter called 'concirge'
//if it is present, then show the modal after a 5 second delay.

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('concierge')) {
    const concierge = urlParams.get("concierge");
    const modal = Modal.getOrCreateInstance(document.getElementById('enquiry-modal'));
    if (concierge == "true") {
        modal.show();
    }
    if(concierge == '1') {
        setTimeout(() => {
            modal.show();
        }, 10000); //display modal after 10 seconds
    }
}

// prevent user from entering a space as the first character in an input field

const elements = document.querySelectorAll('input, textarea');
for(let i = 0; i < elements.length; i++) {
  elements[i].addEventListener('input', function () {
    if (this.value.length === 1 && this.value[0] === ' ') {
      this.value = '';
    }
  });
}